import { GetMemberExternalTransaction } from '@/api/memberExternalTransaction'
import { useShop } from '@/use/shop'

export const useExternalTransactionResolver = ({ fetchTransactions = GetMemberExternalTransaction } = {}) => {
  const { shopId } = useShop()

  const queryTransactionByExactId = async (reference) => {
    const [res, err] = await fetchTransactions({
      shopId: shopId.value,
      exactTransactionId: reference,
    })

    if (err) {
      window.$message.error(err.msg || err)
      return null
    }

    if (!Array.isArray(res) || res.length === 0) {
      window.$message.warning('找不到對應交易紀錄')
      return null
    }

    if (res.length > 1) {
      window.$message.error('對應交易紀錄異常，請稍後再試')
      return null
    }

    return {
      id: res[0].id,
    }
  }

  const resolveExternalTransactionReference = async (reference) => {
    const normalizedReference = typeof reference === 'object' && reference !== null
      ? reference
      : null

    if (!normalizedReference?.value) {
      window.$message.error('交易參照格式錯誤，請稍後再試')
      return null
    }

    if (normalizedReference.type === 'id') {
      return { id: normalizedReference.value }
    }

    if (normalizedReference.type === 'exactTransactionId') {
      return await queryTransactionByExactId(normalizedReference.value)
    }

    window.$message.error('交易參照格式錯誤，請稍後再試')
    return null
  }

  return {
    resolveExternalTransactionReference,
  }
}
